module.exports = __webpack_public_path__ + "static/img/cloud-left-top.805f3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-left-top.png
// module id = 655
// module chunks = 64